import { client } from "../client";

/** Pick a random song from the loaded list and play it (AO2 "Play Random"). */
export function playRandomTrack() {
  const songs: string[] = client.musics || [];
  if (!songs.length) return;
  const pick = songs[Math.floor(Math.random() * songs.length)];
  client.sender.sendMusicChange(pick);
}
window.playRandomTrack = playRandomTrack;

/** Stop the current song using AO2's sentinel track. */
export function stopMusic() {
  client.sender.sendMusicChange("~stop.mp3");
}
window.stopMusic = stopMusic;
